// @file Helper for grouping posts
import { POST_COLOR_STRINGS } from '@@/bits/post_color'
import { WallWishGroupByTypes } from '@@/enums'
import type { Post } from '@@/types'

type GroupByNone = Lowercase<WallWishGroupByTypes.None>
interface Group {
  id: string | number
  [k: string]: any
}

const BLANK_GROUP: Group = { id: WallWishGroupByTypes.None }

const ORDERED_COLOR_GROUPS = POST_COLOR_STRINGS.map((c) => {
  return {
    id: c,
  }
})

const groupByToPostAttributeMap = {
  [WallWishGroupByTypes.Section]: 'wall_section_id',
  [WallWishGroupByTypes.Color]: 'color',
}

const getPostsByGroupByProperty = <T extends Group['id']>(
  posts: Post[],
  sortedGroupByValues: T[],
  groupBy: WallWishGroupByTypes,
): { [K in T | GroupByNone]?: Post[] } => {
  if (groupBy === WallWishGroupByTypes.None) {
    return {
      none: posts,
    }
  }
  return sortedGroupByValues.reduce<{ [K in T | GroupByNone]?: Post[] }>(
    (obj, groupByValue) => ({
      ...obj,
      [groupByValue]: posts.filter((p) => String(p[groupByToPostAttributeMap[groupBy]]) === String(groupByValue)),
    }),
    {},
  )
}

export { BLANK_GROUP, getPostsByGroupByProperty, ORDERED_COLOR_GROUPS }
export type { Group }
